import { Container } from "@components/ui/structure/container";
import { ErrorView } from "@components/view/not-found-view";
import { ReportView } from "@components/view/report-view";
import { ChatDataProvider } from "@contexts/chat-data";
import { useClasses } from "@styles";
import { LayoutProps, PageProps, useRouter } from "@utils/router";

function Layout({ dynamic, forwarded }: LayoutProps) {
  let path = "";

  if (dynamic)
    path = `/${dynamic}`;

  if (forwarded?.length)
    path += `/${forwarded?.join('/')}`;

  return (<>
    <Container className={useClasses("report-page")}>
      {!dynamic && (
        <ErrorView
          code={404}
          message={`Can't reach: ${path}`}
        />
      )}

      {dynamic && !forwarded?.length && (
        <ChatDataProvider chatUuid={dynamic}>
          <ReportView />
        </ChatDataProvider>
      )}
    </Container>
  </>);
}

export function ReportPage({ forwarded } : PageProps) {
  return useRouter(forwarded, Layout, {});
}

